import { useState } from 'react';
import api from '../lib/api';
import { useAuth } from '../hooks/useAuth';

export default function CheckerPage() {
  const [text, setText] = useState('');
  const [mode, setMode] = useState('detect');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const { updateCredits } = useAuth();

  async function analyze() {
    if (!text.trim() || text.length < 20 || loading) return;
    setError(''); setLoading(true); setResult(null);
    try {
      const res = await api.post(`/checker/${mode}`, { text });
      setResult(res.data.data);
      updateCredits(res.data.credits_remaining);
    } catch (e) { setError(e.response?.data?.error || 'Failed'); } finally { setLoading(false); }
  }

  return (
    <div className="fade-up">
      <div className="page-header">
        <h1 className="page-title">AI Checker & Humanizer</h1>
        <p className="page-sub">Detect AI content or humanize it — 2 credits per check</p>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
          <button className={`btn ${mode === 'detect' ? 'btn-black' : 'btn-white'}`} onClick={() => setMode('detect')}>◎ AI Detector</button>
          <button className={`btn ${mode === 'humanize' ? 'btn-black' : 'btn-white'}`} onClick={() => setMode('humanize')}>✦ Humanizer</button>
        </div>

        <div style={{ marginBottom: 12 }}>
          <textarea className="input" style={{ minHeight: 160 }} placeholder={mode === 'detect' ? 'Paste text to check if it was written by AI...' : 'Paste AI-generated text to humanize it...'} value={text} onChange={e => setText(e.target.value)} />
          <div style={{ fontSize: 11, color: '#6B7280', marginTop: 4 }}>{text.length} characters · min 20</div>
        </div>

        <button className="btn btn-orange" onClick={analyze} disabled={loading || text.length < 20}>
          {loading ? 'Analyzing...' : mode === 'detect' ? '◎ Detect AI' : '✦ Humanize Text'}
        </button>
        {error && <div style={{ marginTop: 10, color: '#FF3D57', fontSize: 13, background: '#FFEBEE', padding: '8px 12px', borderRadius: 6 }}>{error}</div>}
      </div>

      {result && mode === 'detect' && (
        <div className="card">
          <div style={{ display: 'flex', gap: 16, alignItems: 'center', marginBottom: 16 }}>
            <div style={{ width: 80, height: 80, borderRadius: '50%', border: `4px solid ${result.score > 70 ? '#FF3D57' : result.score > 40 ? '#FFAB00' : '#00C853'}`, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 24, color: result.score > 70 ? '#FF3D57' : result.score > 40 ? '#FFAB00' : '#00C853' }}>{result.score}%</div>
            <div>
              <div style={{ fontWeight: 800, fontSize: 18 }}>{result.verdict}</div>
              <div style={{ fontSize: 12, color: '#6B7280', marginTop: 2 }}>Confidence: {result.confidence} · {result.markers.length} AI markers found</div>
              <div style={{ fontSize: 13, marginTop: 8, color: '#37474F' }}>{result.summary}</div>
            </div>
          </div>
          {result.markers.length > 0 && (
            <div style={{ marginTop: 12 }}>
              <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: '#6B7280', marginBottom: 6 }}>AI Markers Found</div>
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>{result.markers.map((m,i) => <span key={i} className="badge badge-red" style={{ fontSize: 11 }}>{m}</span>)}</div>
            </div>
          )}
        </div>
      )}

      {result && mode === 'humanize' && (
        <div className="card">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <span style={{ fontWeight: 700 }}>Humanized Text · {result.humanScore}% human score</span>
            <button className="btn btn-white btn-sm" onClick={() => navigator.clipboard.writeText(result.humanized)}>⧉ Copy</button>
          </div>
          <div style={{ background: '#FAFBFC', border: '1px solid #E5E7EB', borderRadius: 6, padding: 16, whiteSpace: 'pre-wrap', fontSize: 13, lineHeight: 1.7, marginBottom: 12 }}>{result.humanized}</div>
          <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: '#6B7280', marginBottom: 6 }}>Improvements Made</div>
          {result.improvements.map((imp,i) => <div key={i} style={{ fontSize: 12, padding: '4px 0', borderBottom: '1px solid #F3F4F6' }}>✓ {imp}</div>)}
        </div>
      )}
    </div>
  );
}
